<app-header></app-header>
<div class="container-fluid" [style.font-family]="'var(--vex-font)'">
  <div class=" bg-one  rounded subheading-2" *ngIf="status">
    <div class="container flex flex-col md:flex-row p-6">
      <div class="md:w-1/2 md:mt-8">
        <img src="assets/images/register-org/register.svg" alt="Register">
      </div>
      <div class="md:w-1/2 p-2 md:p-6 mt--30px">
        <mat-card class="shadow w-full p-4 md:p-6">
          <mat-card-content>
            <h2 class="text-2xl font-semibold mb--10px">
              Your Solution for Smooth Admissions Awaits — Sign Up for Free !
            </h2>
            <form [formGroup]="registerForm" class="mt-15px">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label [style.font-family]="'var(--vex-font)'">Organisation Name</mat-label>
                <input matInput placeholder="Enter Your Organisation Name" formControlName="organisation_name"
                       (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
              </mat-form-field>
              <div class="flex flex-col sm:flex-row sm:gap-4">
                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label [style.font-family]="'var(--vex-font)'">Name</mat-label>
                  <input matInput placeholder="Contact Person's Name" formControlName="name"
                         (keyup)="registerFormStatus()"
                         [style.font-family]="'var(--vex-font)'">
                </mat-form-field>
                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label [style.font-family]="'var(--vex-font)'">Email</mat-label>
                  <input matInput type="email" placeholder="Contact Person's Email" formControlName="email"
                         (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
                </mat-form-field>
              </div>
              <div class="flex flex-col sm:flex-row sm:gap-4">
                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label [style.font-family]="'var(--vex-font)'">Contact</mat-label>
                  <input matInput type="number" placeholder="Contact Person's Contact" formControlName="contact"
                         (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'" numbersOnly>
                </mat-form-field>
                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label [style.font-family]="'var(--vex-font)'">Username</mat-label>
                  <input matInput placeholder="Contact Person's Username" formControlName="username" maxlength="12"
                         [autocomplete]="false" (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
                </mat-form-field>
              </div>
              <div class="flex flex-col sm:flex-row sm:gap-4">
                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label [style.font-family]="'var(--vex-font)'">Password</mat-label>
                  <input matInput type="password" placeholder="Create Password" formControlName="password"
                         (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
                </mat-form-field>
                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label [style.font-family]="'var(--vex-font)'">Confirm Password</mat-label>
                  <input matInput type="password" placeholder="Confirm Password" formControlName="confirm_password"
                         [autocomplete]="false" (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
                </mat-form-field>
              </div>
              <div class="flex items-center justify-center">
                <mat-checkbox class="caption" formControlName="acceptTerms" (click)="keepChecked($event)"
                              [checked]="true"
                              [style.font-family]="'var(--vex-font)'">
                  I accept the <span class="text-blue-600"><a href="/terms-conditions" target="_blank"
                                                              [style.font-family]="'var(--vex-font)'">terms and conditions.</a></span>
                </mat-checkbox>
              </div>
              <button type="button" (click)="otp()"
                      [ngClass]="{ 'active': registerFormValid,'activeHover': registerFormValid, 'inactive': !registerFormValid }"
                      class="mt-20px" [style.font-family]="'var(--vex-font)'">
                Register Organisation <i class="fa fa-unlock font-extrabold ml-5"></i>
              </button>
            </form>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="container bg-one my-10 rounded subheading-2" *ngIf="!status">
    <div class="flex flex-col md:flex-row p-6">
      <div class="p-2 md:p-6 w-full md:w-3/4">
        <p class="text-3xl py-6 font-bold text-gray-800">Check your phone for a 6-digit OTP</p>
        <p class="text-lg text-gray-600 mb-4">We've sent a 6-character code to your registered phone.</p>
        <form [formGroup]="otpForm" class="flex flex-wrap items-center">
          <div class="flex flex-row items-center justify-between w-full max-w-xs gap-2">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="first_key" #otp1 (keyup)="moveFocus(otp1, otp2)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="second_key" #otp2 (keyup)="moveFocus(otp2, otp3)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="third_key" #otp3 (keyup)="moveFocus(otp3, otp4)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="fourth_key" #otp4 (keyup)="moveFocus(otp4, otp5)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="fifth_key" #otp5 (keyup)="moveFocus(otp5, otp6)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="sixth_key" #otp6 (keyup)="moveFocus(otp6, null)">
          </div>
        </form>
        <p class="text-gray-600 mb-4 lh-3rem">Didn't receive the OTP? <span class="text-red-500 cursor-pointer"
                                                                            (click)="otp()">Resend OTP</span>
        </p>
        <button class="py-2 px-4 w-1/2 bg-blue-700 text-white rounded-lg border-none hover:bg-blue-800"
                (click)="signIn()" [disabled]="submitted" *ngIf="!submitted_loader">
          <i class="fa fa-circle-check mr-3px"></i> {{ submitted ? 'Please Wait' : 'Verify' }}
        </button>
        <button class="py-2 px-4 w-1/2 bg-blue-700 text-white rounded-lg border-none hover:bg-blue-800 opacity-8 "
                [disabled]="submitted" *ngIf="submitted_loader" disabled>
          <i class="fa fa-spinner  mr-3px animate-spin"></i> {{ submitted ? 'Please Wait' : 'Verify' }}
        </button>
        <p class="text-sm text-zinc-500 pt-4 cursor-pointer" (click)="goBack()">
          <i class="fa-solid fa-arrow-left text-lg text-bold text-indigo-500"></i> Go Back
        </p>
      </div>
      <div class="w-full md:w-1/4 p-2 md:p-6 flex items-center justify-center">
        <img src="assets/images/OTP%201.png" alt="OTP" class="mx-auto mt-10 max-w-full h-auto">
      </div>
    </div>
  </div>


  <div class="container my-10">
    <div class="text-center py-10">
      <h2 class="text-4xl font-bold text-[#6752a9]">Why Choose Enroll?</h2>
      <p class="text-lg text-gray-700 mt-4">Discover the benefits of using Enroll for your admission management
        needs.</p>
    </div>
    <div class="flex flex-col md:flex-row justify-around items-center gap-8">
      <div class="max-w-sm text-center">
        <img src="assets/images/register-org/ease-of-use.svg" alt="Ease of Use" class="feature-img mx-auto mb-4">
        <h3 class="text-2xl font-semibold text-gray-800">Ease of Use</h3>
        <p class="text-gray-600">Enroll is designed to be user-friendly, ensuring a smooth experience for both staff and
          applicants.</p>
      </div>
      <div class="max-w-sm text-center">
        <img src="assets/images/register-org/time-save.svg" alt="Time-Saving" class="feature-img mx-auto mb-4">
        <h3 class="text-2xl font-semibold text-gray-800">Time-Saving</h3>
        <p class="text-gray-600">Automate repetitive tasks and focus on what matters most—engaging with prospective
          students.</p>
      </div>
      <div class="max-w-sm text-center">
        <img src="assets/images/register-org/secure.svg" alt="Security" class="feature-img mx-auto mb-4">
        <h3 class="text-2xl font-semibold text-gray-800">Secure</h3>
        <p class="text-gray-600">Our platform ensures that all your data is secure, protecting both your institution and
          your applicants.</p>
      </div>
    </div>
  </div>

  <div class="container my-10">
    <div class="text-center py-10">
      <h2 class="text-4xl font-bold text-[#6752a9]">Testimonials</h2>
      <p class="text-lg text-gray-700 mt-4">Hear what our satisfied users have to say about Enroll.</p>
    </div>
    <div class="flex flex-col md:flex-row justify-around items-center gap-8">
      <div class="max-w-md bg-white shadow-lg rounded-lg p-6">
        <p class="text-gray-600">"Enroll has revolutionized the way we handle admissions. The process is now seamless
          and efficient."</p>
        <p class="text-gray-800 font-semibold mt-4">- Ankit Mishra,<i
          class="fa fa-circle-check text-success ml-5 f-12px"></i> Verified </p>
      </div>
      <div class="max-w-md bg-white shadow-lg rounded-lg p-6">
        <p class="text-gray-600">"The user-friendly interface and automated features have saved us countless hours."</p>
        <p class="text-gray-800 font-semibold mt-4">- Deepak Raheja, <i
          class="fa fa-circle-check text-success ml-5 f-12px"></i> Verified</p>
      </div>
      <div class="max-w-md bg-white shadow-lg rounded-lg p-6">
        <p class="text-gray-600">"Enroll's security measures give us peace of mind that our data is protected."</p>
        <p class="text-gray-800 font-semibold mt-4">- Mohit Vij,<i
          class="fa fa-circle-check text-success ml-5 f-12px"> </i> Verified </p>
      </div>
    </div>
  </div>

  <div class="bg-[#6752a9] text-center text-white subheading-2 py-10">
    <h1>Tired of chasing papers? Try chasing success with Enroll instead!</h1>
    <h3 class="my-1">Streamline your admissions process with Enroll.</h3>
    <!--  <button mat-button mat-raised-button class="border-2 my-4 btn-pulse"> Explore with a free trial - Get Register Now ! </button>-->
  </div>
</div>

<app-footer></app-footer>

